module.exports = __webpack_public_path__ + "img/scene_q_ttl.ac282928.png";